module.exports = __webpack_public_path__ + "static/img/GWS-Giants.d681213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GWS-Giants.jpg
// module id = T7Ky
// module chunks = 1